<template>
  <!--<div :class="formItemClass">-->
  <!-- <div :class="[formItemClass,isRequired]"> -->
  <div :class="[formItemClass,isRequired,errorClass]">
    <div
      class="xc-form-item-label"
      :style="{'min-width':labelWidth}"
    >
      <label>{{label}}</label>
    </div>
    <div class="xc-form-item-content">
      <slot></slot>
      <div
        class="xc-form-item-error-tips"
        v-if="error && !hideError"
      >
        {{error}}
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "XcFormItem",
  components: {},
  props: {
    // 类型 0、item 1、item-top
    type: {
      default: 0
    },
    // 标签
    label: {},
    // 必须的
    required: {
      type: Boolean,
      default: false
    },
    // 标签宽度
    labelWidth: {
      type: String,
      default: '65px'
    },
    // 错误
    error: {
      type: String,
      default: null
    },
    // 是否展示error
    hideError: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showLoading: true
    };
  },
  methods: {},
  computed: {
    formItemClass() {
      if (this.type == 0) {
        return "xc-form-item";
      }

      return "xc-form-item-top";
    },
    isRequired() {
      if (this.required) {
        return "xc-form-item-required";
      }
      return "";
    },
    errorClass() {
      if (this.error) {
        return "xc-form-item-error";
      }
    }
  },
  created() {
  }
};
</script>

<style lang="scss" scoped>
</style>
